module.exports = __webpack_public_path__ + "static/media/logo-en_toute_intimite-pink.a53317e5.svg";